import { HttpClient } from 'aurelia-fetch-client';
import { autoinject, LogManager } from 'aurelia-framework';
import { isEmpty } from 'lodash';
import 'whatwg-fetch';
import { NotificationService, NotificationType } from '../components/notifications/notification-service';
import { ResponseHandler } from './response-handler';

@autoinject
export class ApiService {
	constructor(
		private http: HttpClient,
		private responseHandler: ResponseHandler,
		private notificationService: NotificationService) {

		http.configure(config => {
			config
				.withBaseUrl('/api/')
				.withDefaults({
					credentials: 'same-origin',
					headers: {
						'Accept': 'application/json',
						'X-Requested-With': 'Fetch',
						'pragma': 'no-cache',
						'cache-control': 'no-cache'
					}
				})
				.rejectErrorResponses()
				.withInterceptor({
					responseError: (response: Response, request: Request) => {
						if (response.status === 400) {
							return response;
						}

						return this.handleResponseError(response, request);
					}
				});
		});
	}

	fetch(input: Request | string, init?: RequestInit): Promise<Response> {

		input = this.trimInput(input);
		input = this.addCacheBuster(input);

		return this.http.fetch(input, init);
	}

	fetchJson(input: Request | string, init?: RequestInit, errorHandler?: (error: any) => void, cancellationToken?: CancellationToken): Promise<any> {

		input = this.trimInput(input);
		input = this.addCacheBuster(input);

		let isCancelled = false;

		if (cancellationToken != null) {
			cancellationToken.register(() => {
				isCancelled = true;
				console.log('Request cancelled!');
			});
		}

		return this.http.fetch(input, init).then(response => {

			if (!isCancelled) {

				var content = response.json();
				if (!response.ok && errorHandler) {
					errorHandler(content);
					return null;
				}
				return content;
			} else {
				return Promise.reject('cancelled');
			}
		});
	}

	private handleResponseError(response: Response, request: Request): any {
		const errorMessage = `API request '${request.method}' to '${request.url}' failed with status code [${response.status}]`;

		LogManager.getLogger('api-call').error(errorMessage);

		return response;
	}

	private trimInput(input: Request | string) {
		if (typeof input !== 'string' || input == null) { return input; };

		return input.replace(/^\/api\//, '').replace(/^\//, '');
	}

	private addCacheBuster(input: Request | string): Request | string {

		if (typeof input !== 'string' || input == null) { return input; };

		const cachebuster = '_t=' + new Date().getTime();
		const separator = input.indexOf('?') < 0 ? "?" : "&";
		return input + separator + cachebuster;
	}
}

export interface IException {
	data: any;
	innerException: any;
	message: string;
	source: string;
	stackTrace: string;
}

export class CancellationToken {
	private cancellationCallback: () => void;

	cancel() {
		this.cancellationCallback();
	}

	register(callback) {
		this.cancellationCallback = callback;
	}
}
